export enum TextAlign {
  Left = "left",
  Right = "right",
  Center = "center",
}
